import { apiUrl } from "../../../setting";


export const changepasswordUrl = () => {
  return `${apiUrl}/updateUserPassword`;
};